/* istanbul ignore file */
import { FETCH_PRIZE_IMAGE, RECEIVE_PRIZE_IMAGE } from './constants';
import { CFAuthGetMediaRef } from 'auth';
import { locations } from '../../common/redux/action_locations';

export const receivedPrizeImage = (prizeImage, data) => {
  return {
    type: RECEIVE_PRIZE_IMAGE,
    prizeImage,
    data: data.additionalParams
  }
}

export const fetchPrizeImage = (filters, additionalParams) => {
	return {
    type: FETCH_PRIZE_IMAGE,
    fetchCall: fetchPrizeImageCall,
    receivedAction: receivedPrizeImage,
    data: { locations, filters, additionalParams }
  }
}

export const fetchPrizeImageCall = (filename) => {
  return CFAuthGetMediaRef({
    url: `${process.env.REACT_APP_CONTEST_API_URL}/Files/${filename}`,
    params: null,
		originURL: process.env.PUBLIC_URL,
    loaderName: '',
	})
}

export const reducer = (state, { type, prizeImage, data }) => {
  switch (type) {
    case RECEIVE_PRIZE_IMAGE:
      return {
        ...state,
        contestEventResults: {...state.contestEventResults, ['contestEventResults-'+[data.contestEventId]]: {...state.contestEventResults['contestEventResults-'+[data.contestEventId]], ['prizeImage'+data.index]: prizeImage } }
      };
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/features/contests/redux/fetchPrizeImage.js